import {
  getOrder as publicGetOrder,
  listOrders as publicListOrders,
  acceptOrder as publicAcceptOrder,
  cancelOrder as publicCancelOrder,
  fulfillOrder as publicFulfillOrder,
} from './restaurants-v3-order-orders.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onOrderAccepted as publicOnOrderAccepted } from './restaurants-v3-order-orders.public.js';
import { onOrderCanceled as publicOnOrderCanceled } from './restaurants-v3-order-orders.public.js';
import { onOrderCreated as publicOnOrderCreated } from './restaurants-v3-order-orders.public.js';
import { onOrderFulfilled as publicOnOrderFulfilled } from './restaurants-v3-order-orders.public.js';
import { onOrderNewOrder as publicOnOrderNewOrder } from './restaurants-v3-order-orders.public.js';

export const getOrder: MaybeContext<
  BuildRESTFunction<typeof publicGetOrder> & typeof publicGetOrder
> = /*#__PURE__*/ createRESTModule(publicGetOrder);
export const listOrders: MaybeContext<
  BuildRESTFunction<typeof publicListOrders> & typeof publicListOrders
> = /*#__PURE__*/ createRESTModule(publicListOrders);
export const acceptOrder: MaybeContext<
  BuildRESTFunction<typeof publicAcceptOrder> & typeof publicAcceptOrder
> = /*#__PURE__*/ createRESTModule(publicAcceptOrder);
export const cancelOrder: MaybeContext<
  BuildRESTFunction<typeof publicCancelOrder> & typeof publicCancelOrder
> = /*#__PURE__*/ createRESTModule(publicCancelOrder);
export const fulfillOrder: MaybeContext<
  BuildRESTFunction<typeof publicFulfillOrder> & typeof publicFulfillOrder
> = /*#__PURE__*/ createRESTModule(publicFulfillOrder);
/**
 * Triggered when an order is accepted.
 * @deprecated
 */
export const onOrderAccepted: BuildEventDefinition<
  typeof publicOnOrderAccepted
> &
  typeof publicOnOrderAccepted = createEventModule(publicOnOrderAccepted);
/**
 * Triggered when an order is canceled.
 * @deprecated
 */
export const onOrderCanceled: BuildEventDefinition<
  typeof publicOnOrderCanceled
> &
  typeof publicOnOrderCanceled = createEventModule(publicOnOrderCanceled);
/**
 * > **Deprecation Notice**
 * >
 * > **The Order Created webhook has been replaced with**
 * > **the [New Order webhook](https://dev.wix.com/api/rest/wix-restaurants/orders/new-order-webhook)**
 * > **and will be removed on September 30, 2022. If your**
 * > **app uses this webhook, we recommend updating your**
 * > **code as soon as possible.
 * @deprecated
 */
export const onOrderCreated: BuildEventDefinition<typeof publicOnOrderCreated> &
  typeof publicOnOrderCreated = createEventModule(publicOnOrderCreated);
/**
 * Triggered when an order is fulfilled.
 * @deprecated
 */
export const onOrderFulfilled: BuildEventDefinition<
  typeof publicOnOrderFulfilled
> &
  typeof publicOnOrderFulfilled = createEventModule(publicOnOrderFulfilled);
/**
 * Triggered on successful creation of a new order. This means
 * the order has been validated and the payment has cleared,
 * and now the site owner can accept or cancel the order.
 * @deprecated
 */
export const onOrderNewOrder: BuildEventDefinition<
  typeof publicOnOrderNewOrder
> &
  typeof publicOnOrderNewOrder = createEventModule(publicOnOrderNewOrder);

export {
  Status,
  DisplayType,
  DiscountType,
  PaymentType,
  FulfillmentType,
  OnArrival,
  Type,
  EventType,
  FieldName,
  SortOrder,
  WebhookIdentityType,
} from './restaurants-v3-order-orders.universal.js';
export {
  Order,
  LineItem,
  LineItemOption,
  LineItemOptionItem,
  CatalogReference,
  Discount,
  Coupon,
  Payment,
  Fulfillment,
  FulfillmentDetailsOneOf,
  DeliveryDetails,
  DeliveryDetailsProviderOneOf,
  DeliveryAddress,
  DeliveryAddressLocation,
  Restaurant,
  ExternalProvider,
  PickupInfo,
  DropOffInfo,
  PickupDetails,
  Curbside,
  DineInDetails,
  Customer,
  CustomerIdOneOf,
  Totals,
  ServiceFee,
  Money,
  Activity,
  ChannelInfo,
  LoyaltyInfo,
  PosInfo,
  Error,
  PosInfoExternalProvider,
  GetTotalActiveOrdersRequest,
  GetTotalActiveOrdersResponse,
  LocationToAmount,
  NotifyOrderEventRequest,
  Empty,
  GetOrderByMsidRequest,
  GetOrderByMsidResponse,
  ListOrdersByMsidRequest,
  Sort,
  ListOrdersByMsidResponse,
  NotifyOrderEventResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  NewOrder,
  GetOrderRequest,
  GetOrderResponse,
  ListOrdersRequest,
  CursorPaging,
  ListOrdersResponse,
  PagingMetadataV2,
  Cursors,
  AcceptOrderRequest,
  AcceptOrderRequestDeliveryTimeOneOf,
  AcceptOrderResponse,
  OrderAccepted,
  CancelOrderRequest,
  CancelOrderResponse,
  OrderCanceled,
  FulfillOrderRequest,
  FulfillOrderResponse,
  OrderFulfilled,
  CountOrdersRequest,
  CountOrdersQuery,
  DateRangeFilter,
  CountOrdersResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  OrderAcceptedEnvelope,
  OrderCanceledEnvelope,
  OrderCreatedEnvelope,
  OrderFulfilledEnvelope,
  OrderNewOrderEnvelope,
  GetOrderOptions,
  ListOrdersOptions,
  AcceptOrderOptions,
  AcceptOrderOptionsDeliveryTimeOneOf,
  CancelOrderOptions,
} from './restaurants-v3-order-orders.universal.js';
export {
  StatusWithLiterals,
  DisplayTypeWithLiterals,
  DiscountTypeWithLiterals,
  PaymentTypeWithLiterals,
  FulfillmentTypeWithLiterals,
  OnArrivalWithLiterals,
  TypeWithLiterals,
  EventTypeWithLiterals,
  FieldNameWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './restaurants-v3-order-orders.universal.js';
